import { useState } from 'react';
import { useShipmentsOverviewContext } from '@/modules/pmt/context';
import { ShipmentSeparator } from '../ShipmentSeparator';
import { ShipmentCard } from '../ShipmentCard';
import { LoadMore } from '../LoadMore';
import { SectionToggle, SectionHeaderContainer, ShipmentsContainer } from './DeliveredShipments.styles';

export const DeliveredShipments = () => {
  const [expanded, setExpanded] = useState(false);
  const { deliveredShipments, deliveredQueryLimit, noDeliveredShipmentsFound, fetchMoreDelivered, hasMoreDelivered } =
    useShipmentsOverviewContext();

  if (noDeliveredShipmentsFound) return null;

  return (
    <div>
      <SectionHeaderContainer>
        <ShipmentSeparator type='Delivered' color='grey' />
        <SectionToggle isExpanded={expanded} onClick={() => setExpanded((prev) => !prev)} />
      </SectionHeaderContainer>
      {expanded && (
        <ShipmentsContainer>
          {deliveredShipments.slice(0, deliveredQueryLimit).map((shipment) => (
            <ShipmentCard key={shipment.data.firestoreDocId} shipment={shipment} />
          ))}
          {hasMoreDelivered && <LoadMore key='load-more-delivered-shipments' onClick={fetchMoreDelivered} />}
        </ShipmentsContainer>
      )}
    </div>
  );
};
